export function removeTagFromResponse(responseId, tagId) {
  return {
    type: "REMOVE_TAG",
    responseId,
    tagId
  };
}

export function addTagToResponse(responseId, tagId) {
  return {
    type: "ADD_TAG_TO_RESPONSE",
    responseId,
    tagId
  };
}
